import React from 'react';
import { SvgIcon } from '@mui/material';
import './CustomNextSteps.scss';

export const CustomNextSteps = (props) => {
    return (
        <div className="custom-steps-div">
            <h6 className="text-center mt-2"><b>{props.title}</b></h6>
            {props.data.map((item, key) => (
                <div key={key} className='custom-step-list'>
                    <div className='d-flex'>
                        <div className={`icon-container background-color-16`}>
                            <SvgIcon component={item.icon} color='primary' />
                        </div>
                        <div className='main-subtitle mt-1' dangerouslySetInnerHTML={{ __html: item.text }} />
                    </div>
                    {item.subText &&
                        <ul>
                            {item.subText.map((i, k) => (
                                <li key={k}><div className='subtext' dangerouslySetInnerHTML={{ __html: i }} /></li>
                            ))}
                        </ul>
                    }
                    {item.subTitle &&
                        <div className='subtitle' dangerouslySetInnerHTML={{ __html: item.subTitle }} />
                    }
                </div>
            ))}
        </div>
    );
};
